<template>
  <div>
    <header>
      <nav-bar></nav-bar>
    </header>
    <main class="site-content">
      <section class="hero is-danger">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              404&nbsp;<i class="fas fa-exclamation"></i>
            </h1>
            <h2 class="subtitle" style="margin-top: 0.5vh;">
              The page you were looking for was not found!
            </h2>
            <!-- Internet Explorer User may encounter some problems -->
            <div v-if="isIE" class="notification is-danger">
              <div class="has-text-centered">This site is not optimized for Internet Explorer and may not work like expected!</div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <vue-headful title="Not Found | IceTiger" description="Home of IceTiger, a German Furry." keywords="icetiger, furry" url="https://icetiger.eu/"></vue-headful>
    <foot-bar></foot-bar>
  </div>
</template>
<script>
export default {
  name: 'NotFound',
  data: function() {
    return {
      isIE: /Trident\/|MSIE/.test(window.navigator.userAgent)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue